export default __webpack_public_path__ + "images/7a33c02c8c81dfb1492981f9037f8182-aov-selected.svg";